import React from "react";
import { useEntities } from "@hooks/useEntities";
import type { InvoiceGroupSlice } from "./groupHelpers";
import { AccrualImporterRow, AccrualMode } from "../types";
import { useAccrualImporterColumns } from "../useAccrualImporterColumns";
import { AccrualImporterGroupedSections } from "./AccrualImporterGroupedSections";

interface Props {
    mode: AccrualMode;
    groups: InvoiceGroupSlice[];
    setRows: React.Dispatch<React.SetStateAction<AccrualImporterRow[]>>;
    addLineItemToGroup: (rowIndex: number) => void;
    removeRow: (rowIndex: number) => void;
    addNewInvoice: () => void;
    counterpartiesMap: Map<string, string>;
}

export const AccrualImporterGroupedSectionsView: React.FC<Props> = ({
    mode,
    groups,
    setRows,
    addLineItemToGroup,
    removeRow,
    addNewInvoice,
    counterpartiesMap,
}) => {
    const entities = useEntities({ onlyBusiness: true });

    const columns = useAccrualImporterColumns({
        mode,
        counterpartiesMap,
        entities,
    });

    return (
        <AccrualImporterGroupedSections
            mode={mode}
            setRows={setRows}
            addLineItemToGroup={addLineItemToGroup}
            removeRow={removeRow}
            addNewInvoice={addNewInvoice}
            columns={columns}
            groups={groups}
        />
    );
};
